import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Grid from '../../components/Grid.js';
import PagingBar from '../../components/PagingBar.js';
import ApiService from '../../services/ApiService.js';
import { getWords } from '../../utils/get-words.js';
import { protect } from '../../utils/protect.js';

const BudgetOperationTopPart4 = ReactRouterDOM.withRouter(function ({ budgetOperation }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [count, setCount] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const pageSize = 10;
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    setPageNumber(1);
    loadCount();
  }, [budgetOperation]);

  React.useEffect(() => {
    loadRecords();
  }, [pageNumber, budgetOperation]);

  const loadCount = async function () {
    try {
      const args = {};
      if (budgetOperation.budgetOperationId !== null && budgetOperation.budgetOperationId !== undefined) {
        args.budgetOperationBudgetOperationId = budgetOperation.budgetOperationId;
      }
      setCount(await ApiService.getCountBudgetOperationAudits(args));
    }
    catch (error) {
      setError(error);
      return;
    }
  }
  
  const loadRecords = async function () {
    let records = null;
    try {
      const args = {};
      if (budgetOperation.budgetOperationId !== null && budgetOperation.budgetOperationId !== undefined) {
        args.budgetOperationBudgetOperationId = budgetOperation.budgetOperationId;
      }
      args.offset = (pageNumber - 1) * pageSize;
      args.limit = pageSize;
      records = await ApiService.getBudgetOperationAudits(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    setItems(records.map((record, index) => ({
      key: record.budgetOperationAuditId,
      data: [
        record.datetime,
        protect(function ([firstName, lastName]) { return `${firstName} ${lastName}` }, [ record.userFirstName, record.userLastName ]),
        record.janCount,
        record.janOldCount,
        record.febCount,
        record.febOldCount,
        record.marCount,
        record.marOldCount,
        record.aprCount,
        record.aprOldCount,
        record.mayCount,
        record.mayOldCount,
        record.junCount,
        record.junOldCount,
        record.julCount,
        record.julOldCount,
        record.augCount,
        record.augOldCount,
        record.sepCount,
        record.sepOldCount,
        record.octCount,
        record.octOldCount,
        record.novCount,
        record.novOldCount,
        record.decCount,
        record.decOldCount,
      ],
      record: record
    })));
  }
  
  const refreshMe = async function () {
    await loadCount();
    await loadRecords();
  }
  
  return (
    <div>
      <div>
        <Grid
          contextualActions={[
          ]}
          fields={[
            {
              label: words.datetime,
              type: 'datetime',
              bindIndex: 0,
              secondaryField: {
                type: 'string',
                bindIndex: 1,
              },
            },
            {
              label: words.jan,
              type: 'integer',
              alignment: 'right',
              bindIndex: 2,
              comparativeField: {
                type: 'integer',
                bindIndex: 3,
              },
            },
            {
              label: words.feb,
              type: 'integer',
              alignment: 'right',
              bindIndex: 4,
              comparativeField: {
                type: 'integer',
                bindIndex: 5,
              },
            },
            {
              label: words.mar,
              type: 'integer',
              alignment: 'right',
              bindIndex: 6,
              comparativeField: {
                type: 'integer',
                bindIndex: 7,
              },
            },
            {
              label: words.apr,
              type: 'integer',
              alignment: 'right',
              bindIndex: 8,
              comparativeField: {
                type: 'integer',
                bindIndex: 9,
              },
            },
            {
              label: words.may,
              type: 'integer',
              alignment: 'right',
              bindIndex: 10,
              comparativeField: {
                type: 'integer',
                bindIndex: 11,
              },
            },
            {
              label: words.jun,
              type: 'integer',
              alignment: 'right',
              bindIndex: 12,
              comparativeField: {
                type: 'integer',
                bindIndex: 13,
              },
            },
            {
              label: words.jul,
              type: 'integer',
              alignment: 'right',
              bindIndex: 14,
              comparativeField: {
                type: 'integer',
                bindIndex: 15,
              },
            },
            {
              label: words.aug,
              type: 'integer',
              alignment: 'right',
              bindIndex: 16,
              comparativeField: {
                type: 'integer',
                bindIndex: 17,
              },
            },
            {
              label: words.sep,
              type: 'integer',
              alignment: 'right',
              bindIndex: 18,
              comparativeField: {
                type: 'integer',
                bindIndex: 19,
              },
            },
            {
              label: words.oct,
              type: 'integer',
              alignment: 'right',
              bindIndex: 20,
              comparativeField: {
                type: 'integer',
                bindIndex: 21,
              },
            },
            {
              label: words.nov,
              type: 'integer',
              alignment: 'right',
              bindIndex: 22,
              comparativeField: {
                type: 'integer',
                bindIndex: 23,
              },
            },
            {
              label: words.dec,
              type: 'integer',
              alignment: 'right',
              bindIndex: 24,
              comparativeField: {
                type: 'integer',
                bindIndex: 25,
              },
            },
          ]}
          items={items}
        />
        {count !== null && count !== undefined ?
          <PagingBar
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            countOfItems={count}
            countOfPages={Math.ceil(count/pageSize)}
          /> :
          null
        }
      </div>
    </div>
  );
})

export default BudgetOperationTopPart4;
